import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import Image from 'next/image';
import cx from 'classnames';

// Utils
import { PropertyType } from '@gql';

// UI
import { Typography } from '@components/typography';
import house from '@public/assets/svg/property-type-icons/house.svg';
import apartment from '@public/assets/svg/property-type-icons/apartment.svg';
import guestHouse from '@public/assets/svg/property-type-icons/guest-house.svg';
import bedAndBreakfast from '@public/assets/svg/property-type-icons/bed-and-breakfast.svg';
import boutiqueHotel from '@public/assets/svg/property-type-icons/hotel.svg';
import { mapPropertyTypeToTitle } from './map-property-type-to-title';
import { Button } from '@components/button';
type Props = {
  propertyType: PropertyType;
  onClick: () => void;
  selected: boolean;
};
export const PropertySelectionCard: React.FC<Props> = t0 => {
  const $ = _c(19);
  const {
    propertyType,
    onClick,
    selected
  } = t0;
  let t1;
  if ($[0] !== selected) {
    t1 = cx("text-primary-dark", "border-primary-main", "rounded-xl", "w-full", "flex", "flex-col", "items-center", "justify-center", "gap-1.5", "px-3", "py-4", "bg-white", "hover:bg-pool/40", "hover:text-primary-dark", "transition-colors", {
      "bg-pool/50 border-primary-main border-[1.5px]": selected,
      "text-primary-dark": selected
    });
    $[0] = selected;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== propertyType) {
    t2 = enumToSvgPropertyTypes(propertyType);
    $[2] = propertyType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== propertyType) {
    t3 = mapPropertyTypeToTitle(propertyType);
    $[4] = propertyType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Image src={t2} className="text-primary-main" alt={t3} width="28" />;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== propertyType) {
    t5 = mapPropertyTypeToTitle(propertyType);
    $[9] = propertyType;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <Typography variant="body2" component="p" className="leading-tight text-center">{t5}</Typography>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onClick || $[14] !== propertyType || $[15] !== t1 || $[16] !== t4 || $[17] !== t6) {
    t7 = <Button key={propertyType} color="gray" variant="outlined" onClick={onClick} className={t1}>{t4}{t6}</Button>;
    $[13] = onClick;
    $[14] = propertyType;
    $[15] = t1;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
const propertyTypeIconMap: Partial<Record<PropertyType, string>> = {
  [PropertyType.House]: house,
  [PropertyType.Apartment]: apartment,
  [PropertyType.GuestHouse]: guestHouse,
  [PropertyType.BoutiqueHotel]: boutiqueHotel,
  [PropertyType.BedAndBreakfast]: bedAndBreakfast
};
const enumToSvgPropertyTypes = (propertyType: PropertyType): string => propertyTypeIconMap[propertyType] ?? house;